import React from "react";
import Highcharts from "highcharts";
import HighchartsReact from "highcharts-react-official";

export default function Speedometer({
  value = 0,
  maxValue = 200,
  fillProgress = false,
}) {
  const fillColor = "var(--mantine-color-gray-9)";

  const plotBands = fillProgress
    ? (() => {
        const numBands = 100; // More granular bands for partial fill
        const bands = [];

        for (let i = 0; i < numBands; i++) {
          const from = (maxValue * i) / numBands;
          const to = (maxValue * (i + 1)) / numBands;

          // Determine if this band should be filled
          let fillPercentage = 0;
          if (value >= to) {
            fillPercentage = 1; // Fully filled
          } else if (value > from) {
            fillPercentage = (value - from) / (to - from); // Partial fill
          }

          bands.push({
            from,
            to,
            color:
              fillPercentage > 0 ? "var(--mantine-color-green-5)" : fillColor,
            thickness: 20,
            borderRadius: "5%",
            fillPercentage, // Store for potential use
          });
        }

        return bands;
      })()
    : [
        {
          from: 0,
          to: maxValue * 0.6,
          color: "var(--mantine-color-green-5)", // green
          thickness: 20,
          borderRadius: "50%",
        },
        {
          from: maxValue * 0.75,
          to: maxValue,
          color: "var(--mantine-color-red-5)", // yellow
          thickness: 20,
          borderRadius: "50%",
        },
        {
          from: maxValue * 0.55,
          to: maxValue * 0.8,
          color: "var(--mantine-color-yellow-5)", // red
          thickness: 20,
          // borderRadius: "50%",
        },
      ];

  return (
    <HighchartsReact
      highcharts={Highcharts}
      options={{
        chart: {
          backgroundColor: "transparent",
          type: "gauge",
          plotBackgroundColor: null,
          plotBackgroundImage: null,
          plotBorderWidth: 0,
          plotShadow: false,
          // marginBottom: -20,
          height: "300px",
          style: {
            fontFamily: "inherit",
            backgroundColor: "transparent",
            borderRadius: "2px",
          },
        },
        responsive: {
          rules: [
            {
              condition: {
                maxWidth: 500,
              },
              chartOptions: {
                chart: {
                  height: "250px",
                },
              },
            },
            {
              condition: {
                maxWidth: 424,
              },
              chartOptions: {
                chart: {
                  height: "225px",
                },
              },
            },
            {
              condition: {
                maxWidth: 386,
              },
              chartOptions: {
                chart: {
                  height: "200px",
                },
              },
            },
            {
              condition: {
                maxWidth: 355,
              },
              chartOptions: {
                chart: {
                  height: "175px",
                },
              },
            },
            {
              condition: {
                maxWidth: 322,
              },
              chartOptions: {
                chart: {
                  height: "165px",
                },
              },
            },
            {
              condition: {
                maxWidth: 306,
              },
              chartOptions: {
                chart: {
                  height: "140px",
                },
              },
            },
          ],
        },
        title: null,

        pane: {
          startAngle: -90,
          endAngle: 89.9,
          background: null,
          center: ["50%", "80%"],
          size: "130%",
        },
        plotOptions: {
          series: {
            groupPadding: 0,
          },
        },
        // the value axis
        yAxis: {
          min: 0,
          max: maxValue,
          // tickPixelInterval: 72,
          tickPixelInterval: fillProgress ? 50 : 72,
          tickPosition: "inside",
          tickColor: fillProgress
            ? "transparent"
            : "var(--mantine-color-gray-9)",
          tickLength: 20,
          tickWidth: 2,
          minorTickInterval: null,
          labels: {
            distance: 20,
            style: {
              fontSize: "12px",
              color: "var(--mantine-color-gray-6)",
            },
          },
          title: {
            enabled: false,
            text: "",
          },
          lineWidth: 0,
          plotBands,
        },
        credits: {
          enabled: false,
        },
        exporting: {
          enabled: false,
        },

        tooltip: {
          enabled: false,
        },
        series: [
          {
            name: "",
            data: [value >= maxValue ? maxValue : value],
            dataLabels: {
              enabled: false,
            },
            dial: {
              radius: "80%",
              backgroundColor: "var(--mantine-color-gray-4)",
              baseWidth: 12,
              baseLength: "0%",
              rearLength: "0%",
            },
            pivot: {
              backgroundColor: "var(--mantine-color-gray-4)",
              radius: 8,
            },
          },
        ],
      }}
    />
  );
}
